import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';

export const CustomFormulaModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        Your Custom Formula<sup>Rx</sup>
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <Typography className="cur-mt-4">
        Your provider will{' '}
        <span className="cur-font-bold">review your answers and photos</span>{' '}
        and then <span className="cur-font-bold">pick 3</span> of the following
        active ingredients for your skin&apos;s unique needs.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Active ingredients
      </Typography>
      <IngredientsAccordion
        body="Gently exfoliates to help unclog pores, smooth texture, and brighten
        skin"
        title="Azelaic acid"
      />
      <IngredientsAccordion
        body="Soothes inflammation and helps keep bacteria and fungi in check"
        title="Zinc pyrithione"
      />
      <IngredientsAccordion
        body="Helps clear acne and smooth out texture and fine lines"
        title="Tretinoin"
      />
      <IngredientsAccordion
        body="Soothes inflammation, fades dark spots, and fights free radicals"
        title="Niacinamide"
      />
      <IngredientsAccordion
        body="Fights acne-causing bacteria and inflammation"
        title="Clindamycin phosphate"
      />
      <IngredientsAccordion
        body="Can help soothe inflammation, including redness and swelling"
        title="Metronidazole"
      />
      <IngredientsAccordion
        body="Helps treat redness, inflammation, and acne-like bumps from rosacea"
        title="Ivermectin"
      />
      <IngredientsAccordion
        body="Helps stop the cycle of stubborn hormonal acne"
        title="Spironolactone"
      />
      <Typography className="cur-mt-4" size="h3">
        Inactive ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Aloe Barbadensis Leaf Juice, C13-C14 Isoparaffin, Caprylic/Capric
        Triglyceride, Deionized Water, Laureth-7, Phenoxyethanol,
        Polyacrylamide, Tocopheryl Acetate, Triethylene Glycol
      </Typography>
      <Typography className="cur-mt-4">
        All formulas containing tretinoin also contain the antioxidant butylated
        hydroxytoluene (BHT), and all formulas containing spironolactone contain
        propylene glycol.
      </Typography>
      <Typography className="cur-mt-4">
        Formulas containing both niacinamide and azelaic acid may also contain
        propylene glycol.
      </Typography>
    </>
  );
};
